import { Link } from "react-router-dom";
import { WhatsAppIcon } from "@/components/site/icons";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, waLink } from "@/lib/contact";

const NAV = [
  { id: "ayuda", label: "Cómo ayudamos" },
  { id: "modelo", label: "Modelo de tratamiento" },
  { id: "familia", label: "Familia" },
  { id: "faq", label: "Preguntas frecuentes" },
];

function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function Footer({ compliant = false }) {
  return (
    <footer className="relative overflow-hidden bg-ink text-[#B9C9BB]" data-testid="site-footer">
      <img
        src="/assets/logo-mark.png"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute -right-16 -top-16 w-80 opacity-[0.05]"
      />
      <div className="relative mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <img src="/assets/logo-mark.png" alt="CESMA" className="mb-4 h-12 w-auto" />
            <b className="font-serif text-2xl text-white">CESMA</b>
            <p className="mt-3 max-w-[34ch] text-[0.92rem] text-[#98AA9A]">
              {compliant
                ? "Clínica de bienestar emocional en Cuernavaca, Morelos. Operado por Salud Integral Alas Enlazadas A.C."
                : "Clínica Especialista en Salud Mental y Adicciones en Cuernavaca, Morelos. Operado por Salud Integral Alas Enlazadas A.C."}
            </p>
          </div>

          {!compliant && (
            <div>
              <h4 className="mb-4 text-[0.78rem] font-bold uppercase tracking-[0.14em] text-[#7f9584]">
                Navegación
              </h4>
              <ul className="grid gap-3 text-[0.92rem]">
                {NAV.map((n) => (
                  <li key={n.id}>
                    <button
                      onClick={() => scrollToId(n.id)}
                      className="text-[#C7D5C8] transition-colors hover:text-white"
                      data-testid={`footer-nav-${n.id}`}
                    >
                      {n.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div>
            <h4 className="mb-4 text-[0.78rem] font-bold uppercase tracking-[0.14em] text-[#7f9584]">
              Contacto
            </h4>
            <ul className="grid gap-3 text-[0.92rem]">
              <li>
                <a href={`tel:${PHONE_TEL}`} className="text-[#C7D5C8] hover:text-white" data-testid="footer-phone">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="text-[#C7D5C8] hover:text-white" data-testid="footer-email">
                  {EMAIL}
                </a>
              </li>
              <li>Lisboa 9, Col. Burgos</li>
              <li>Cuernavaca, Morelos · Atención 7 días</li>
              <li>
                <a
                  href={waLink("Hola, quiero información sobre CESMA.")}
                  target="_blank"
                  rel="noopener"
                  className="inline-flex items-center gap-2 text-[#C7D5C8] hover:text-white"
                  data-testid="footer-whatsapp"
                >
                  <WhatsAppIcon className="h-4 w-4" /> WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-wrap justify-between gap-5 border-t border-white/10 pt-6 text-[0.82rem] text-[#7f9584]">
          <span>© 2026 CESMA · Salud Integral Alas Enlazadas A.C. Todos los derechos reservados.</span>
          <span>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">
              Aviso de privacidad
            </Link>{" "}
            · Registros COFEPRIS · CLUNI
          </span>
        </div>
      </div>
    </footer>
  );
}
